import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { MiniStoreThemeContext } from "../../../MiniStoreContexts/MiniStoreThemeContext";
import { HiShoppingBag } from "react-icons/hi2";
import { FiChevronsLeft } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { CartContext } from "../../../contexts/MiniStore/CartContext";

const MsCartButton = () => {
  const { theme } = useContext(MiniStoreThemeContext);
  const { cartCount, subTotal } = useContext(CartContext);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 400);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 400);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const navigate = useNavigate();

  const handleCartClick = () => {
    if (cartCount < 1) return;
    navigate("/mini-store/cart");
  };
  const handlePayClick = () => {
    if (cartCount < 1) return;
    navigate("/mini-store/checkout");
  };
  useEffect(() => {
    // console.log("subTotal", subTotal);
  }, [subTotal]);

  return (
    <CartButtonContainer theme={theme} isExpanded={isExpanded}>
      <CartIconContainer onClick={() => handleCartClick()}>
        <CartIcon theme={theme} />
        {cartCount > 0 && <Badge theme={theme}>{cartCount}</Badge>}
      </CartIconContainer>
      <CartDetails isExpanded={isExpanded}>
        <TotalContainer theme={theme}>
          <CartTotal theme={theme}>Total</CartTotal>
          {subTotal}
        </TotalContainer>
        <PayButton theme={theme} onClick={handlePayClick}>
          {isMobile ? "Pay" : "iON Pay"}
        </PayButton>
      </CartDetails>
      <ToggleIcon
        onClick={() => setIsExpanded((prev) => !prev)}
        theme={theme}
        isExpanded={isExpanded}
      >
        <FiChevronsLeft />
      </ToggleIcon>
    </CartButtonContainer>
  );
};

export default MsCartButton;

const ToggleIcon = styled.div`
  z-index: 1000;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  margin-left: ${({ isExpanded }) => (isExpanded ? "0.15rem" : "1.5rem")};
  align-items: center;
  justify-content: center;
  svg {
    color: ${({ theme }) => theme.textColor.primary};
    font-size: 30px;
    transition: transform 0.3s ease;
    transform: rotate(${({ isExpanded }) => (isExpanded ? "0deg" : "180deg")});
  }
`;
const CartButtonContainer = styled.div`
  font-family: Outfit, sans-serif;
  display: flex;
  justify-content: start;
  align-items: center;
  background: ${({ theme }) => theme.primaryColor.primary};
  padding: ${({ isExpanded }) => (isExpanded ? "10px 10px" : "10px")};
  border-radius: 0.15rem;
  width: ${({ isExpanded }) => (isExpanded ? "calc(100% - 32px)" : "100px")};
  bottom: 65px;
  box-shadow: 0 9px 25px 0 rgba(132, 128, 177, 0.28);
  left: 16px;
  position: fixed;
  z-index: 999;
  transition: width 0.3s ease, padding 0.3s ease;
  @media (max-width: 450px) {
    bottom: 40px;
    padding: ${({ isExpanded }) => (isExpanded ? "6px" : "6px")};
    width: ${({ isExpanded }) => (isExpanded ? "calc(100% - 32px)" : "92px")};
  }
`;

const CartIconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  cursor: pointer;
`;

const CartIcon = styled(HiShoppingBag)`
  color: ${({ theme }) => theme.textColor.primary};
  font-size: 26px;
`;

const Badge = styled.span`
  background: ${({ theme }) => theme.textColor.primary};
  color: ${({ theme }) => theme.primaryColor.primary};
  font-size: 8px;
  font-weight: bold;
  padding: 2px 7px;
  border-radius: 0.15rem;
  position: absolute;
  top: -5px;
  right: -20px;
`;
const CartDetails = styled.div`
  display: ${({ isExpanded }) => (isExpanded ? "flex" : "none")};
  align-items: center;
  gap: 10px;
  margin-left: auto;
`;
const TotalContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 25px;
  background: ${({ theme }) => theme.textColor.primary};
  color: ${({ theme }) => theme.primaryColor.primary};
  font-size: 16px;
  font-weight: bold;
  padding: 5px 12px;
  border-radius: 0.15rem;
  box-shadow: ${({ theme }) => theme.boxShadow.primary};
  @media (max-width: 425px) {
    font-size: 12px;
    gap: 10px;
  }
`;
const CartTotal = styled.span`
  color: ${({ theme }) => theme.primaryColor.primary};
`;
const PayButton = styled.button`
  background: ${({ theme }) => theme.textColor.primary};
  color: ${({ theme }) => theme.primaryColor.primary};
  font-size: 14px;
  font-weight: bold;
  padding: 5px 15px;
  border: none;
  border-radius: 0.15rem;
  cursor: pointer;
  margin-left: 10px;
  box-shadow: ${({ theme }) => theme.boxShadow.primary};

  &:hover {
    opacity: 0.8;
  }
  @media (max-width: 425px) {
    font-size: 12px;
    margin-left: 0px;
  }
`;
